import { fromJS } from 'immutable'
import {
  REPORT_COMPENSATE_CANCEL_REQUEST,
  REPORT_COMPENSATE_CANCEL_SUCCESS,
  REPORT_COMPENSATE_CANCEL_FAILURE,
  REPORT_COMPENSATE_CANCEL_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case REPORT_COMPENSATE_CANCEL_REQUEST:
      return state
        .set('isFetching', true)
    case REPORT_COMPENSATE_CANCEL_SUCCESS:
      return state
        .set('isFetching', false)
        .set('canceledCompensate', fromJS(action.payload.canceledCompensate))
        .set('status', 200)
        .set('message', 'Canceled Successfully.')
    case REPORT_COMPENSATE_CANCEL_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
        .set('status', 'Error')
        .set('canceledCompensate', fromJS(action.payload.message))
        .set('message', fromJS(action.payload.response.message))
    case REPORT_COMPENSATE_CANCEL_RESET:
      return state
        .delete('canceledCompensate')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/report/report-compensate-work-cancel-reducer.js